
    import './styles.scoped.css';
    export default {
  "card-inner": "awsui_card-inner_p8a6i_1yaj3_161",
  "root": "awsui_root_p8a6i_1yaj3_193",
  "header-variant-full-page": "awsui_header-variant-full-page_p8a6i_1yaj3_232",
  "header-refresh": "awsui_header-refresh_p8a6i_1yaj3_232",
  "list": "awsui_list_p8a6i_1yaj3_239",
  "list-grid-1": "awsui_list-grid-1_p8a6i_1yaj3_250",
  "card": "awsui_card_p8a6i_1yaj3_161",
  "list-grid-2": "awsui_list-grid-2_p8a6i_1yaj3_253",
  "list-grid-3": "awsui_list-grid-3_p8a6i_1yaj3_256",
  "list-grid-4": "awsui_list-grid-4_p8a6i_1yaj3_259",
  "list-grid-5": "awsui_list-grid-5_p8a6i_1yaj3_262",
  "list-grid-6": "awsui_list-grid-6_p8a6i_1yaj3_265",
  "list-grid-7": "awsui_list-grid-7_p8a6i_1yaj3_268",
  "list-grid-8": "awsui_list-grid-8_p8a6i_1yaj3_271",
  "list-grid-9": "awsui_list-grid-9_p8a6i_1yaj3_274",
  "list-grid-10": "awsui_list-grid-10_p8a6i_1yaj3_277",
  "list-grid-11": "awsui_list-grid-11_p8a6i_1yaj3_280",
  "list-grid-12": "awsui_list-grid-12_p8a6i_1yaj3_283",
  "list-grid-13": "awsui_list-grid-13_p8a6i_1yaj3_286",
  "list-grid-14": "awsui_list-grid-14_p8a6i_1yaj3_289",
  "list-grid-15": "awsui_list-grid-15_p8a6i_1yaj3_292",
  "list-grid-16": "awsui_list-grid-16_p8a6i_1yaj3_295",
  "list-grid-17": "awsui_list-grid-17_p8a6i_1yaj3_298",
  "list-grid-18": "awsui_list-grid-18_p8a6i_1yaj3_301",
  "list-grid-19": "awsui_list-grid-19_p8a6i_1yaj3_304",
  "list-grid-20": "awsui_list-grid-20_p8a6i_1yaj3_307",
  "selection-control": "awsui_selection-control_p8a6i_1yaj3_311",
  "loading": "awsui_loading_p8a6i_1yaj3_321",
  "empty": "awsui_empty_p8a6i_1yaj3_322",
  "has-header": "awsui_has-header_p8a6i_1yaj3_329",
  "refresh": "awsui_refresh_p8a6i_1yaj3_332",
  "card-header": "awsui_card-header_p8a6i_1yaj3_403",
  "card-header-inner": "awsui_card-header-inner_p8a6i_1yaj3_411",
  "card-selectable": "awsui_card-selectable_p8a6i_1yaj3_415",
  "card-selected": "awsui_card-selected_p8a6i_1yaj3_418",
  "section": "awsui_section_p8a6i_1yaj3_426",
  "section-header": "awsui_section-header_p8a6i_1yaj3_434",
  "section-content": "awsui_section-content_p8a6i_1yaj3_440",
  "footer-pagination": "awsui_footer-pagination_p8a6i_1yaj3_450"
};
  